module.exports = __webpack_public_path__ + "static/img/共享运营平台.fa53723c.png";